import React, { useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
  useLocation,
  useOutletContext,
} from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { usePatient } from "../../context/PatientContext";
import PatientPaymentForm from "../Forms/PatientPaymentForm";
import axios from "axios";
import CONFIG from "../../config";
import "../../Styles/PatientPaymentForm.css";

const EditPatientPaymentForm = () => {
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  console.log()
  const { markSectionComplete } = useOutletContext();
  console.log("inside payment");
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const {
    patientData,
    setPatientData,
    updateExistingCaseVisit,
    addNewCaseVisit,
    addExistingCaseVisit,
    selectedCase,
    selectedVisit,
    doctorInfo,
  } = usePatient();
  console.log(patientData);
  const { patientId, caseId, visitId } = useParams();
  console.log(patientId);
  const location = useLocation();

  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  /**
   * Identify which backend action to trigger
   */
  const determineVisitAction = () => {
    if (!patientData) return null;
    const actionStatus = patientData?.ACTION_STATUS;

    switch (actionStatus) {
      case "UPDATE_EXISTING_VISIT":
        return "updateExistingCaseVisit";
      case "ADD_NEW_CASE":
        return "addNewCaseVisit";
      case "ADD_NEW_VISIT":
        return "addExistingCaseVisit";
      default:
        return null;
    }
  };

  /**
   * Fetch previous balance from backend
   */
  const fetchPreviousBalance = async () => {
    try {
      const response = await axios.get(
        `${CONFIG.BASE_URL}/patients/${patientId}/balance`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            doctorId: doctorInfo.MANDALI_ID,
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE,
          },
        }
      );
      return response.data?.previous_balance || 0;
    } catch (error) {
      console.error("Error fetching previous balance:", error);
      return 0;
    }
  };

  /**
   * Submit handler for patient payment
   */
  const onSubmitHandler = async (updatedPaymentData, options = {}) => {
    const isAutoSave = options?.isAutoSave;
    console.log("Updated payment data from form:", updatedPaymentData);

    // ✅ Extract only database fields from the form data
    const {
      PREVIOUS_BALANCE,
      CONSULTING_CHARGES,
      PANCHKARMA_CHARGES,
      CURRENT_PAYMENT,
      MEDICINE_CHARGES,
      NEW_BALANCE
    } = updatedPaymentData;

    // ✅ Prepare payment data with ONLY database columns
    const paymentDataForDB = {
      PREVIOUS_BALANCE,
      CONSULTING_CHARGES,
      PANCHKARMA_CHARGES,
      CURRENT_PAYMENT,
      NEW_BALANCE,
      MEDICINE_CHARGES,
      PATIENT_ID: patientData.PATIENT_ID,
      CASE_ID: selectedCase || caseId,
      VISIT_ID: selectedVisit || visitId,
      MANDALI_ID: doctorInfo.MANDALI_ID,
      CLINIC_ID: doctorInfo.CLINIC_ID,
    };

    console.log("Payment data prepared for database:", paymentDataForDB);

    const updatedData = {
      ...patientData,
      patientPayment:
        patientData?.patientPayment?.length > 0
          ? patientData.patientPayment.map((info) => ({
            ...info,
            ...paymentDataForDB,
          }))
          : [paymentDataForDB],
    };

    setPatientData(updatedData);

    console.log("Updated patient data after Payment update:", patientData);

    if (!isAutoSave) {
      markSectionComplete("payment");
    }

    // markSectionComplete("payment");
    // if (location.pathname.startsWith("/addpatient")) {
    //   navigate("/addpatient/nextvisit");
    // } else if (location.pathname.startsWith("/visits")) {
    //   navigate(`/visits/${patientId}/${caseId}/${visitId}/nextvisit`);
    // } else {
    //   console.warn("Unknown route, no redirection");
    // }
  };
  const handleContinue = () => {
    markSectionComplete("payment");
    if (location.pathname.startsWith("/addpatient")) {
      navigate("/addpatient/nextvisit");
    } else if (location.pathname.startsWith("/visits")) {
      navigate(`/visits/${patientId}/${caseId}/${visitId}/nextvisit`);
    } else {
      console.warn("Unknown route, no redirection");
    }
  };

  return (
    <div className="edit-patient-container">
      {patientData && (
        <PatientPaymentForm
          initialValues={patientData}
          fetchPreviousBalance={fetchPreviousBalance}
          onSubmit={onSubmitHandler}
          onAutoSave={(values) => onSubmitHandler(values, { isAutoSave: true })}
          onContinue={handleContinue}
          patientName={patientData?.patientInfo?.[0]?.PATIENT_NAME}
          enableReinitialize={true}
        />
      )}
    </div>
  );
};

export default EditPatientPaymentForm;